import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const INVOICE_PAYMENTS_BASE_URL = process.env.REACT_APP_WC12_BASE_URL;
console.log("INVOICE_PAYMENTS_BASE_URL",INVOICE_PAYMENTS_BASE_URL);
console.log("BASE_URL",BASE_URL);
export const sbwcHomPage = process.env.REACT_APP_SBWC_HOME_PAGE;
export const paymentsHomPage = process.env.REACT_APP_PAYMENTS_HOME_PAGE;

interface TokenResponse {
    token: string;
    tokenExpiration: string;
}

class WC12PaymentService {
    async wc12Payment(paymentRequest: any): Promise<any> {
        try {
            // Step 1: Generate the token
            const tokenResponse = await axios.post<TokenResponse>(
                `${INVOICE_PAYMENTS_BASE_URL}/token/generatetoken`,
                paymentRequest
            );

            console.log('WC12 generatetoken response:', tokenResponse.data);

            const decodedToken: any = jwtDecode(tokenResponse.data.token);
            console.log('WC12 decoded JWT token:', decodedToken);

            localStorage.setItem("paymentToken", tokenResponse.data.token);
            localStorage.setItem("paymentTokenExpiration", tokenResponse.data.tokenExpiration);

            if (tokenResponse && tokenResponse.data) {
                // Step 2: Search invoice payment using the token
                const paymentResponse = await axios.post(
                    `${INVOICE_PAYMENTS_BASE_URL}/searchinvoicepayment`,
                    paymentRequest,
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.data.token}`,
                        }
                    }
                );

                console.log('WC12 searchinvoicepayment response:', paymentResponse.data);
                return paymentResponse.data;
            } else {
                throw new Error('Token generation failed');
            }
        } catch (error) {
            return Promise.reject(error);
        }
    }

    async refreshToken(invoiceNumber: any, claimNumber: any): Promise<any> {
        try {
            const token = localStorage.getItem("paymentToken");
            if (token && invoiceNumber && claimNumber) {
                const refreshResponse = await axios.post<TokenResponse>(
                    `${INVOICE_PAYMENTS_BASE_URL}/token/refreshtoken`,
                    {
                        token: token,
                        invoiceNumber: invoiceNumber,
                        claimNumber: claimNumber,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    }
                );
                localStorage.setItem("paymentToken", refreshResponse.data.token);
                localStorage.setItem("paymentTokenExpiration", refreshResponse.data.tokenExpiration);
                return refreshResponse;
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
            throw new Error('Token refresh failed');
        }
    }

    async getPaymentDetails(): Promise<any> {
        try {
            const token = Cookies.get('authToken');
            if (!token) throw new Error('No token found');

            return this.getPaymentDetailsWithToken(token);
        } catch (error) {
            console.error('Error fetching payment details:', error);
            throw error;
        }
    }

    async getPaymentDetailsWithToken(token: string): Promise<any> {
        try {
            const response = await axios.get<any>(`${INVOICE_PAYMENTS_BASE_URL}/getInvoicePaymentConfirmation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log('WC12 getInvoicePaymentConfirmation response:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching payment details:', error);
            throw error;
        }
    }

    async getPaymentRequest(email: string, paymentMethod: string, outStandingAmount: string): Promise<any> {
        try {
            const token = localStorage.getItem("paymentToken");
            if (!token) throw new Error('No token found');

            const response = await axios.get<any>(
                `${INVOICE_PAYMENTS_BASE_URL}/getInvoicePaymentRequestInformation`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        email: email,
                        paymentMethod: paymentMethod,
                        outStandingAmount: outStandingAmount,
                    },
                }
            );

            console.log('WC12 getInvoicePaymentRequestInformation response:', response.data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new WC12PaymentService();
